<template>
  <div class="breadcrumb">
    <page-link to="/">Home</page-link>
    <template v-if="page.category">
      <font-awesome-icon icon="angle-right"></font-awesome-icon>
      <page-link :to="page.category.url">{{ page.category.name }}</page-link>
    </template>
    <template v-if="page.parent">
      <font-awesome-icon icon="angle-right"></font-awesome-icon>
      <page-link :to="page.parent.url">{{ page.parent.name }}</page-link>
    </template>
    <template v-else>
      <font-awesome-icon icon="angle-right"></font-awesome-icon>
      <span>{{page.name}}</span>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  created() {},
  computed: {
    ...mapState(["page"])
  }
}
</script>

<style scoped>
.breadcrumb {
  padding-bottom: 2rem;
  color: #666;
}

.breadcrumb svg {
  margin: 0 1rem;
  color: #132460;
}

.breadcrumb a:hover {
  color: #cd0b0e;
}
</style>
